module.exports = __webpack_public_path__ + "static/img/654_phase_function_Paper_Points.1c8c187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/654_phase_function_Paper_Points.png
// module id = 0oIu
// module chunks = 0